import { render } from "./AddressAutofillInput.vue?vue&type=template&id=21196e2c"
import script from "./AddressAutofillInput.vue?vue&type=script&lang=js"
export * from "./AddressAutofillInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__